import {User} from '@drl/core/auth/models/user.model';
import {MessageRecipient} from './message-recipient.model';
import {NbIconConfig} from '@nebular/theme';

export class ChatMessage {
  id?: string;
  subject?: string;
  type?: 'text' | 'quote' | 'file' = 'text';
  body: string;
  status?: number;
  expireOn?: string;
  patientUserId: number;
  toUserId?: number;
  channelId?: string;
  channelKey?: string;
  categoryId?: number;
  parentId?: string;
  parent?: ChatMessage;
  contentId?: string;
  contentUrl?: string;
  contentType?: string;
  content?: {icon: NbIconConfig | string; url: string; type?: string};
  createdBy?: number;
  sender?: User;
  createdOn?: Date;
  messageRecipients?: MessageRecipient[];
  displayTitle?: string;
}
